import { SET_ALERT, ACTION_SET_ALERT } from '../../types/alerts.types'

export default {
  [ACTION_SET_ALERT]: ({ commit }, payload) => {
    commit(SET_ALERT, payload)
  },
}
